class StatusUtils {
    findById (id) {
        for(let status in this){
            if(this.hasOwnProperty(status) && this[status].id === id){
                return this[status];
            }
        }
    }
}

export default {
    COMPLETION : new (class extends StatusUtils {
        NONE = {
            id : 1,
            name : 'None',
        };
        PARTIALLY = {
            id : 2,
            name : 'Partially',
        };
        FULLY = {
            id : 3,
            name : 'Fully',
        };
    }),
    ORDER : new (class extends StatusUtils {
        OPEN = {
            id : 1,
            name : 'Open',
        };
        CLOSED = {
            id : 2,
            name : 'Closed',
        };
        CANCELED = {
            id : 3,
            name : 'Canceled',
        };
        HOLD = {
            id : 4,
            name : 'On Hold',
        };
        FAILED = {
            id : 5,
            name : 'Failed',
        };
        NO_SHIPPING_METHOD = {
            id : 6,
            name : 'No Shipping Method'
        };
        NOT_MANAGEED = {
            id : 7,
            name : 'Not Managed',
        };
        DRAFT = {
            id : 8,
            name : 'Draft'
        }
    }),
    PAYMENT : new (class extends StatusUtils {
        UNAUTHORIZED = {
            id : 1,
            name : 'Unauthorized',
        };
        AUTHORIZED = {
            id : 2,
            name : 'Authorized',
        };
        PAID = {
            id : 3,
            name : 'Paid',
        };
        DEFERRED = {
            id : 4,
            name : 'Deferred',
        };
        REFUNDED = {
            id : 5,
            name : 'Refunded',
        };
        CREDITED = {
            id : 6,
            name : 'Credited',
        };
        AWAITING_CLEARANCE = {
            id : 7,
            name : 'Awaiting Clearance',
        };
        DECLINED = {
            id : 8,
            name : 'Declined',
        };
        REFUND_PENDING = {
            id : 9,
            name : 'Refund Pending',
        };
        REFUND_FAILED = {
            id : 10,
            name : 'Refund Failed',
        };
    }),
    PAYMENT_REFUND : new (class extends StatusUtils {
        NONE = {
            id : 1,
            name : 'None',
        };
        PARTIALLY = {
            id : 2,
            name : 'Partially',
        };
        FULLY = {
            id : 3,
            name : 'Fully',
        };
    }),
    ALLOCATION : new (class extends StatusUtils {
        NONE = {
            id : 1,
            name : 'None',
        };
        PARTIAL = {
            id : 2,
            name : 'Partial',
        };
        FULLY = {
            id : 3,
            name : 'Fully',
        };
    }),
    ACKNOWLEDGED : new (class extends StatusUtils {
        NONE = {
            id : 1,
            name : 'None',
        };
        PARTIAL = {
            id : 2,
            name : 'Partial',
        };
        FULLY = {
            id : 3,
            name : 'Fully',
        };
    }),
    SHIPPED : new (class extends StatusUtils {
        NONE = {
            id : 1,
            name : 'Unshipped',
        };
        PARTIAL = {
            id : 2,
            name : 'Partial',
        };
        FULLY = {
            id : 3,
            name : 'Shipped',
        };
    }),
    SOURCE_INVOICE : new (class extends StatusUtils {
        NONE = {
            id : 1,
            name : 'No POs Have Invoices Attached',
        };
        PARTIAL = {
            id : 2,
            name : 'Some POs Have Invoices Attached',
        };
        FULLY = {
            id : 3,
            name : 'All POs Have Invoices Attached',
        };
    }),
    TRANSACTION : new (class extends StatusUtils {
        NONE = {
            id : 0,
            name : 'None',
            className : '',
        };
        SUCCESS = {
            id : 1,
            name : 'Success',
            className : 'is-link',
        };
        DECLINED = {
            id : 2,
            name : 'Declined',
            className : 'is-danger',
        };
        ERROR = {
            id : 3,
            name : 'Error',
            className : 'is-danger',
        };
    }),
    TRANSACTION_TYPE : new (class extends StatusUtils {
        CHARGE = {
            id : 1,
            name : 'Charge',
            className : 'is-link',
        };
        REFUND = {
            id : 2,
            name : 'Refund',
            className : 'is-danger',
        };
        CREDIT = {
            id : 3,
            name : 'Credit',
            className : 'is-warning',
        };
    }),
    PURCHASE_ORDER : new (class extends StatusUtils {
        UNPROCESSED = {
            id : 1,
            name : 'Unprocessed',
            className : 'is-link',
        };
        PROCESSED = {
            id : 2,
            name : 'Processed',
            className : 'is-info',
        };
        ACKNOWLEDGED = {
            id : 3,
            name : 'Acknowledged',
            className : 'is-success',
        };
        CANCELED = {
            id : 4,
            name : 'Canceled',
            className : 'is-danger',
        };
        FAILED = {
            id : 5,
            name : 'Failed',
            className : 'is-danger',
        };
        VOIDED = {
            id : 6,
            name : 'Voided',
            className : 'is-warning',
        };
        PROCESSING = {
            id : 7,
            name : 'Processing',
            className : 'is-warning'
        };
        NO_SHIPPING_METHOD = {
            id : 8,
            name : 'No Shipping Method',
            className : 'is-danger',
        };
        PO_NUMBER_EXCEEDS_MAX_LENGTH = {
            id : 9,
            name : 'PO # Exceeds Max Length',
            className : 'is-danger',
        };
    }),
    FULFILLMENT : new (class extends StatusUtils {
        AWAITING_SHIPMENT = {
            id : 1,
            name : 'Awaiting Shipment',
            className : 'is-link',
        };
        SHIPPED = {
            id : 2,
            name : 'Shipped',
            className : 'is-info',
        };
        PARTIALLY_SHIPPED = {
            id : 3,
            name : 'Partially Shipped',
            className : 'is-warning',
        };
        CANCELED = {
            id : 4,
            name : 'Canceled',
            className : 'is-danger',
        };
    }),
    INVOICE : new (class extends StatusUtils {
        UNPAID = {
            id : 1,
            name : 'Unpaid',
            className : 'is-warning',
        };
        PAID = {
            id : 2,
            name : 'Paid',
            className : 'is-info',
        };
        CREDITED = {
            id : 3,
            name : 'Credited',
            className : 'is-warning',
        };
        REFUNDED = {
            id : 4,
            name : 'Refunded',
            className : 'is-danger',
        };
    }),
    DEALER : new (class extends StatusUtils {
        PENDING = {
            id : 1,
            name : 'Pending',
            className : 'info',
        };
        APPROVED = {
            id : 2,
            name : 'Approved',
            className : 'primary',
        };
        ACTIVE = {
            id : 3,
            name : 'Active',
            className : 'success',
        };
        INACTIVE = {
            id : 5,
            name : 'Inactive',
            className : 'warning',
        };
        DENIED = {
            id : 4,
            name : 'Denied',
            className : 'danger',
        };
        CANCELED = {
            id : 6,
            name : 'Canceled',
            className : 'danger',
        };
        CANCEL_PENDING = {
            id : 7,
            name : 'Cancel Pending',
            className : 'danger',
        };
    }),
};

